import BaseObject from '../../../base/base_object';
import OAuth2AnonymousState from './oauth2_anonymous_state';
import OAuth2AuthorizedState from './oauth2_authorized_state';
import Token from '../tokens/token';

export default class OAuth2StateFactory extends  BaseObject {
    static CLASS = 'OAuth2StateFactory';


    _stateChangedCallback = null;
    _backendProxy = null;
    _serviceFactory = null;
    _inactivityTimeoutSettingsPersister = null;
    _getSessionTimerUrl = null;
    init(params) {
        super.init(params);
        this._stateChangedCallback = params.stateChangedCallback;
        this._backendProxy = params.backendProxy;
        this._serviceFactory = params.serviceFactory;
        this._inactivityTimeoutSettingsPersister = params.inactivityTimeoutSettingsPersister;
        this._getSessionTimerUrl = params.getSessionTimerUrl;

    }

    createAnonymousState(params) {
        return OAuth2AnonymousState.create(Object.assign({}, params, this._getDependencies()));
    }

    createAuthorizedStateForNewLogin(tokenData, hasRememberMe, sessionTimerOffset) {
        let token =  Token.fromNew({
            tokenData: tokenData,
            hasRememberMe: hasRememberMe,
            sessionTimerOffset: sessionTimerOffset
        });

        return OAuth2AuthorizedState.forNewLogin(this._getAuthorizedStateParams(token));
    }

    createAuthorizedStateForExistingToken(token) {
        return OAuth2AuthorizedState.forExistingToken(this._getAuthorizedStateParams(token));
    }

    _getAuthorizedStateParams(token) {
        return Object.assign(
            {
                token: token,
                inactivityTimeoutSettingsPersister: this._inactivityTimeoutSettingsPersister,
                getSessionTimerUrl: this._getSessionTimerUrl
            },
            this._getDependencies())
    }

    _getDependencies() {
        return {
            stateChangedCallback: this._stateChangedCallback,
            backendProxy: this._backendProxy,
            serviceFactory: this._serviceFactory,
            oauth2StateFactory: this
        };
    }

    createInitialState() {

        let token = Token.fromStorage();
        if(token.isExpired()) {
            return this.createAnonymousState();
        } else {
            return this.createAuthorizedStateForExistingToken(token);
        }
    }
}